import { MSummary } from '@Models/client/my-account.model'
import { MCommonProduct } from '@Models/common.model'
import { Grow } from '@mui/material'
import { CommonService } from '@Services/common.service'
import clsx from 'clsx'
import * as _ from 'lodash'
import { useEffect, useState } from 'react'
import BoxContainer from '../../../components/Box/BoxContainer/BoxContainer'

// models section
interface ISummary {
    data: MCommonProduct[]
    className: string
    getCalculateProductsPrice: (products: MCommonProduct[]) => void
}

function Summary(props: ISummary) {
    // core section
    const { data, className, getCalculateProductsPrice } = props
    const ac = new AbortController()

    // state section
    const [generatedProducts, setGeneratedProducts] = useState<MSummary[]>([])

    // functions section
    const generatePrice = (price: string, index: number) => {
        const convertedPrice = +price?.replace('$', '')
        return index < 2 ? convertedPrice - index * 30 : convertedPrice - 40

        // if (index === 0) {
        //     return convertedPrice
        // }
        // if (index === 1) {
        //     return convertedPrice > 31 ? convertedPrice - 30 : 0
        // }
        // return convertedPrice > 60 ? convertedPrice - 60 : 0
    }

    const generateTotal = () => {
        let total = 0
        _.each(generatedProducts, function (value: MSummary) {
            total += +value?.price?.replace('$', '')
        })

        return total
    }

    // hooks section
    useEffect(() => {
        const firearms = data
            ?.filter((item) => item?.type === 'FIREARM')
            ?.map((firearm, index: number) => {
                const totalAmount = generatePrice(
                    String(firearm?.itemSubscription?.totalAmount),
                    index
                ).toFixed(2)
                return {
                    ...firearm,
                    itemSubscription: {
                        ...firearm?.itemSubscription,
                        totalAmount,
                    },
                }
            })

        const other = data
            ?.filter((item) => item?.type !== 'FIREARM')
            ?.map((item) => {
                return {
                    ...item,
                    itemSubscription: {
                        ...item?.itemSubscription,
                        totalAmount:
                            item?.itemSubscription?.totalAmount > 39.99
                                ? 39.99
                                : item?.itemSubscription?.totalAmount,
                    },
                }
            })

        const result = [...firearms, ...other]

        getCalculateProductsPrice(result)
        setGeneratedProducts(result?.map((item) => new MSummary(item)))

        return () => {
            ac.abort()
        }
    }, [data])

    // elements section
    const summaryElements = generatedProducts?.map(
        (item: MSummary, index: number) => {
            return (
                <div
                    className={clsx('detail')}
                    key={`${item?.name}_summary_${+index}`}
                >
                    <div className="detail-content">
                        <span className="name">{item?.name || ' - '}</span>
                        <span className="price">
                            {item?.price}{' '}
                            {/* {CommonService.currencyFormat(
                                    generatePrice(item?.price, index)
                                )} */}
                        </span>
                    </div>
                    <div className="id">
                        {item?.serialCode ? `#${item?.serialCode}` : '# - '}
                    </div>
                </div>
            )
        }
    )

    // main
    return (
        <BoxContainer
            className={clsx('summary-box', className)}
            title="Summary"
        >
            {data?.length ? (
                <>
                    {summaryElements}
                    <div className="total">
                        <div className="title">Total Prices</div>
                        <div className="price">
                            {CommonService.currencyFormat(generateTotal())}
                        </div>
                    </div>
                </>
            ) : (
                <div className="text-center">No data</div>
            )}
        </BoxContainer>
    )
}

export default Summary
